<template>
<div>
  <vb-form-row item-name="生年月日" :required="true">
    <template #title>
      <v-tooltip v-model="openHint.birthdate"
                 :open-on-hover="false"
                 :open-on-click="false"
                 top
                 color="transparent"
                 v-if="!isCharibon"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            @click="openHint.birthdate = !openHint.birthdate"
            color="grey lighten-1"
          >
            mdi-help-circle
          </v-icon>
        </template>
        <v-card v-if="openHint.birthdate"
                v-click-outside="openHint.birthdate? onClickToolTipBirthdateOutside : null"
                flat outlined>
          <v-card-title class="pa-3 pb-1 text-subtitle-2">生年月日について</v-card-title>
          <v-card-text class="pa-3 pt-0">古物営業法に基づき、生年月日をお知らせいただく必要がございます。</v-card-text>
        </v-card>
      </v-tooltip>
    </template>
    <template #input>
      <v-sheet class="col-4 pa-0" max-width="164">
        <validation-provider
          v-slot="{ errors, invalid }"
          name="年"
          :rules="`required` + (isCharibon ? `` : `|age_18_or_over:@birthdateYear,@birthdateMonth,@birthdateDay`)"
          vid="birthdateYear"
        >
          <v-select
            :value="formLabelsGetter.birthdateYear ? Number(formLabelsGetter.birthdateYear) : null"
            @input="formLabelsSetter({name:'birthdateYear', value: $event})"
            @change="changeDaysOptions"
            @blur="blurBgColorChange($event, errors[0])"
            @focus="focusBgColorChange($event, errors[0])"
            name="birthdateYear"
            :items="optionYears()"
            required
            outlined
            dense
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            height="44px"
            class="align-center"
            :eager="true"
            hide-details="auto"
            solo
            flat
          >
            <template #append-outer>年</template>
          </v-select>
          <p v-if="errors[0]" class="error--text pt-1 mb-0 text-caption">{{ errors[0] }}</p>
        </validation-provider>
      </v-sheet>
      <v-sheet class="col-4 py-0 pr-0" :class="$vuetify.breakpoint.mdAndUp ? 'pl-8': 'pl-4'" max-width="164">
        <validation-provider
          v-slot="{ errors, invalid }"
          name="月"
          :rules="`required` + (isCharibon ? `` : `|age_18_or_over:@birthdateYear,@birthdateMonth,@birthdateDay`)"
          vid="birthdateMonth"
        >
          <v-select
            :value="formLabelsGetter.birthdateMonth ? Number(formLabelsGetter.birthdateMonth) : null"
            @input="formLabelsSetter({name:'birthdateMonth', value: (String($event)).padStart(2, '0')})"
            @change="changeDaysOptions"
            @blur="blurBgColorChange($event, errors[0])"
            @focus="focusBgColorChange($event, errors[0])"
            name="birthdateMonth"
            :items="optionMonths()"
            outlined
            dense
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            width="100px"
            height="44px"
            class="align-center"
            hide-details="auto"
            solo
            flat
          >
            <template #append-outer>月</template>
          </v-select>
          <p v-if="errors[0]" class="error--text pt-1 mb-0 text-caption">{{ errors[0] }}</p>
        </validation-provider>
      </v-sheet>
      <v-sheet class="col-4 py-0 pr-0" :class="$vuetify.breakpoint.mdAndUp ? 'pl-8': 'pl-4'" max-width="164">
        <validation-provider
          v-slot="{ errors, invalid }"
          name="日"
          :rules="`required` + (isCharibon ? `` : `|age_18_or_over:@birthdateYear,@birthdateMonth,@birthdateDay`)"
          vid="birthdateDay"
        >
          <v-select
            :value="formLabelsGetter.birthdateDay ? Number(formLabelsGetter.birthdateDay) : null"
            @input="formLabelsSetter({name:'birthdateDay', value: (String($event)).padStart(2, '0')})"
            @blur="blurBgColorChange($event, errors[0])"
            @focus="focusBgColorChange($event, errors[0])"
            name="birthdateDay"
            :items="days"
            required
            outlined
            dense
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            height="44px"
            class="align-center flex-nowrap"
            hide-details="auto"
            solo
            flat
          >
            <template #append-outer>日</template>
          </v-select>
          <p v-if="errors[0]" class="error--text pt-1 mb-0 text-caption">{{ errors[0] }}</p>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
export default {
  name: "vb-birth-date",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formLabelsSetter: {
      type: Function,
      required: true
    },
    formLabelsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  created() {
    this.changeDaysOptions();
  },
  data() {
    return {
      days: [],
      openHint: {
        birthdate: false,
      }
    }
  },
  methods: {
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    changeDaysOptions() {
      const year = this.formLabelsGetter.birthdateYear != null ? this.formLabelsGetter.birthdateYear : this.optionYears()[0];
      const month = this.formLabelsGetter.birthdateMonth != null ? this.formLabelsGetter.birthdateMonth : 1;
      const lastDayOfMonth = new Date(year, month, 0);
      this.days = Array.from({length: lastDayOfMonth.getDate()}, (v, k) => k + 1);
    },
    optionYears() {
      const currentYear = new Date().getFullYear();
      const upperLimit = currentYear - 100;
      // Charibonは年齢制限なし
      const lowerLimit = currentYear - (this.isCharibon ? 1 : 18);
      return Array.from({length: lowerLimit - upperLimit + 1}, (_, v) => lowerLimit - v);
    },
    optionMonths() {
      return Array.from({length: 12}, (_, v) => v + 1);
    },
    updateBirthdate() {
      this.formItemsSetter({
        name: 'birthdate',
        value: `${this.formLabelsGetter.birthdateYear}-${this.formLabelsGetter.birthdateMonth}-${this.formLabelsGetter.birthdateDay}`
      });
    },
    onClickToolTipBirthdateOutside() {
      this.openHint.birthdate = false;
    },
  },
  watch: {
    formLabelsGetter: {
      handler: function (updateObject) {
          this.formItemsSetter({
            name: 'birthdate',
            value: `${updateObject.birthdateYear}-${updateObject.birthdateMonth}-${updateObject.birthdateDay}`
          });
      },
      deep: true
    }
  },
  computed: {
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    }
  }
}
</script>

<style scoped>

</style>